/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetSearchCondition,
    GetSearchConditionFromJSON,
    GetSearchConditionFromJSONTyped,
    GetSearchConditionToJSON,
} from './GetSearchCondition';
import {
    GetSearchConditionsResponseAllOf,
    GetSearchConditionsResponseAllOfFromJSON,
    GetSearchConditionsResponseAllOfFromJSONTyped,
    GetSearchConditionsResponseAllOfToJSON,
} from './GetSearchConditionsResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetSearchConditionsResponse
 */
export interface GetSearchConditionsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetSearchConditionsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetSearchConditionsResponse
     */
    message: string;
    /**
     * 
     * @type {Array<GetSearchCondition>}
     * @memberof GetSearchConditionsResponse
     */
    data: Array<GetSearchCondition>;
}

export function GetSearchConditionsResponseFromJSON(json: any): GetSearchConditionsResponse {
    return GetSearchConditionsResponseFromJSONTyped(json, false);
}

export function GetSearchConditionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSearchConditionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(GetSearchConditionFromJSON)),
    };
}

export function GetSearchConditionsResponseToJSON(value?: GetSearchConditionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(GetSearchConditionToJSON)),
    };
}

